// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"fa6c078a","498":"5f217e29","513":"56b5d952","703":"df0b35cf"}[chunkId] + ".chunk.js";
};